import {useDispatch, useSelector} from "react-redux";
import {SquareArrowOutUpRight} from "lucide-react";
import {snowplowTrackEvent} from "utils/snowplow";
import * as reduxSelectors from "components/store/application.reducers";
import {editorDetach} from "components/taskdetails-remake/taskDetails.action";
import ModuleMenu from "components/taskdetails/navigation/ModuleMenu.component";
import {MenuItem} from "components/common/menu/MenuItem.component";
import type {EditorUserConfiguration, Translate} from "types/editor";

interface EditorModuleMenuProps {
    /** the data-cy of the module the menu sits in; the menu and its items take it as a prefix */
    dataCy: string;
    translate: Translate;
}

/**
 * The module menu of the editor modules (the external editor and the accounting grid): the shared items, then
 * "Open editor in a new window", which moves both editor modules into their own window, as the editor button
 * of the classic page's sidebar does. Closing that window reattaches them.
 */
export const EditorModuleMenu = ({dataCy, translate}: EditorModuleMenuProps) => {
    const dispatch = useDispatch();
    const userConfiguration: EditorUserConfiguration = useSelector(reduxSelectors.getUsersData);

    const detachEditor = () => {
        dispatch(editorDetach());
        snowplowTrackEvent({
            category: "task_detail",
            action: "sidebar-detach-editor-option",
            label: "detach-editor-option",
        }, userConfiguration);
    };

    return (
        <ModuleMenu dataCy={`${dataCy}.menu`}>
            <MenuItem label={translate("taskDetail.openEditorInNewWindow")}
                      icon={SquareArrowOutUpRight}
                      onClick={detachEditor}
                      dataCy={`${dataCy}.menu.detachEditor`}/>
        </ModuleMenu>
    );
};

export default EditorModuleMenu;
